import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownSelectButtonComponent } from './dropdown-select-button.component';
import { DropdownSelectItemComponent } from './dropdown-select-item/dropdown-select-item.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        DropdownSelectButtonComponent,
        DropdownSelectItemComponent
    ],
    exports: [
        DropdownSelectButtonComponent,
        DropdownSelectItemComponent
    ]
})
export class DropdownSelectButtonModule { }
